export function joinUrl(baseUrl, fileKey) {
  return `${baseUrl || ''}/${fileKey}`.replace(/\/+/g, '/').replace(':/', '://')
}

export function resolveUploadedFileUrl(response, baseUrl = '') {
  const fileUrl = response?.url || response?.data?.url || response?.fileName || response?.data?.fileName
  if (!fileUrl) return ''
  return /^https?:\/\//i.test(fileUrl) ? fileUrl : joinUrl(baseUrl, fileUrl)
}
